import { useState } from 'react';
import { toast } from 'sonner';
import { useSupabaseAuth } from '@/contexts/SupabaseAuthContext';
import { uploadBase64Image } from '@/services/supabaseStorage';

export const useImageUpload = () => {
  const [isUploading, setIsUploading] = useState(false);
  const { user, session } = useSupabaseAuth();

  const uploadImage = async (base64Image: string, itemId: string): Promise<string | null> => {
    setIsUploading(true);
    try {
      if (!session || !user) {
        toast.error('Please log in to upload images');
        return null;
      }

      const fileName = `${itemId}_${Date.now()}.jpg`;
      const filePath = await uploadBase64Image(base64Image, 'lost-and-found-photos', fileName);

      toast.success('File uploaded successfully');
      return filePath;
      
    } catch (error: any) {
      console.error('Unexpected error during upload:', error);
      toast.error(error.message || 'An unexpected error occurred during upload');
      return null;
    } finally {
      setIsUploading(false);
    }
  };

  return {
    uploadImage,
    isUploading,
  };
};
